/* ==========================================================================
   VP READ MORE / READ LESS
   Reusable <vp-read-more> custom element.
   Wrap any long content block + a .vp-read-more__toggle button inside it.
   Only shows the toggle if the content actually overflows the clamp,
   or if there's more than one child element hidden below the first.
   ========================================================================== */
(function () {
  function setup(el) {
    var content = el.querySelector('.vp-read-more__content');
    var toggle = el.querySelector('.vp-read-more__toggle');
    var toggleText = el.querySelector('.vp-read-more__toggle-text');
    if (!content || !toggle) return;

    function checkOverflow() {
      var firstEl = content.firstElementChild;
      if (!firstEl) return;

      var hasMoreSiblings = content.children.length > 1;
      var firstIsClamped = firstEl.scrollHeight > firstEl.clientHeight + 2;

      if (hasMoreSiblings || firstIsClamped) {
        el.classList.add('has-overflow');
      } else {
        el.classList.remove('has-overflow');
      }
    }

    toggle.addEventListener('click', function () {
      var expanded = el.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggleText.textContent = expanded ? 'Read Less' : 'Read More';
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  }

  function init() {
    document.querySelectorAll('vp-read-more').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
